import { Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BusinessStore } from 'src/model/business/business-store';
import { createEmptyFiscalYearInfo, FiscalYearInfo, FiscalYearValidator } from 'src/model/fiscalYearInfo.model';
import { FiscalYearInfoService } from 'src/services/fiscal-year-info.service';
import { ALERT_TYPE, SUCCESS_MESSAGES } from '../constants';
import { SharedService } from '../Shared/shared-service.service';

@Component({
  selector: 'app-add-update-fiscal-year-info',
  standalone: false,
  templateUrl: './add-update-fiscal-year-info.component.html',
  styleUrl: './add-update-fiscal-year-info.component.scss',
})
export class AddUpdateFiscalYearInfoComponent {
  public activeModal = inject(NgbActiveModal);
  private fyInfoService = inject(FiscalYearInfoService);
  private sharedService = inject(SharedService);
  private businessStore = inject(BusinessStore);

  branchBusinessMap = this.businessStore.branchBusinessMap;
  branchMap = this.businessStore.branchMap;

  @Input() lockBusiness: boolean = false;
  @Input() isEdit: boolean = false;
  @Input() selectedBusinessId: number;
  @Input() selectedBranchId: number;
  @Input() fyInfoToUpdate: FiscalYearInfo;
  fyInfo = signal<FiscalYearInfo>(createEmptyFiscalYearInfo());
  @Output() passEntry = new EventEmitter<any>();

  readonly fiscalYears = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - 1 + i);

  ngOnInit(): void {
    this.reset();
  }

  async submit() {
    this.fyInfo.update(f => ({...f, BranchId: this.selectedBranchId}));
    const errors = FiscalYearValidator.isNull(this.fyInfo());
    if (errors.length > 0) {
      this.sharedService.openAlert(errors.map(e => `- ${e}`).join('\n'), ALERT_TYPE.DANGER);
    } else {
      const branchId = this.fyInfo().BranchId;
      const business = this.branchBusinessMap().get(branchId);
      const branchName = this.branchMap().get(branchId).Name;
      const branchText = branchName.length > 0 ? ` (${branchName})` : '';
      let message = '';
      let res: FiscalYearInfo;
      if (this.isEdit) {
        res = await this.fyInfoService.putFiscalYearInfo(this.fyInfo());
        message = SUCCESS_MESSAGES.UPDATED_FOR('fiscal year info', `${business.Name}${branchText} of ${this.fyInfo().FiscalYear}`);
      } else {
        res = await this.fyInfoService.postFiscalYearInfo(this.fyInfo());
        message = SUCCESS_MESSAGES.ADDED_FOR('fiscal year info', `${business.Name}${branchText} of ${this.fyInfo().FiscalYear}`);
      }
      res.BusinessId = business.Id;
      this.passEntry.emit(res);
      this.activeModal.close(true);
      this.sharedService.openAlert(message, ALERT_TYPE.SUCCESS);
    }
  }

  reset() {
    if (this.fyInfoToUpdate) {
      this.fyInfo.set({ ...this.fyInfoToUpdate });
      this.selectedBusinessId = this.fyInfo().BusinessId;
      this.selectedBranchId = this.fyInfo().BranchId;
    } else
      this.fyInfo.set(createEmptyFiscalYearInfo());
  }
}
